import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/player-position-stacking/actions';
import Const from 'constants';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class SecondaryStackOptions extends Component {
    onChange(isChecked, combinationType) {
        this.props.dispatch(
            Action.set('SecondaryStackCombinationTypeOfPlayerPositionStacking', combinationType, isChecked),
        );
    }

    render() {
        const {stacking} = this.props;
        const content = [];

        if (stacking.isSecondaryStackUsed()) {
            const combinations = stacking.getSecondaryStackCombinations();

            Object.keys(Const.SECONDARY_STACK_COMBINATION_TYPES).map((type) => {
                content.push(
                    <InputCheckbox
                        key={type}
                        label={Const.SECONDARY_STACK_COMBINATION_TYPE_LABELS[type]}
                        checked={combinations[type]}
                        onChange={(value) => ::this.onChange(value, type)}
                    />,
                );
            });
        }

        return <>{!!content.length && <div className="correlation-checkboxes">{content}</div>}</>;
    }
}

function mapStatesToProps(state) {
    const {playerPositionStacking} = state;

    return {
        stacking: playerPositionStacking,
    };
}

export default connect(mapStatesToProps)(SecondaryStackOptions);
